// extracted by mini-css-extract-plugin
export var tosLink = "_at-0";